import Vue from 'vue';
import {
  Toast
} from 'vant'
Vue.use(Toast)
let vm = new Vue();
var checkBroswer = function() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  console.log(ua)
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}
var showErrorToast = function(msg) {
  if (msg != undefined && msg != "") {
    Toast(msg)
  } else {
    Toast("數據出錯啦~請稍後再試", 'center')
  }
}
var toFix = function(value) {
  if (typeof(value) == "number" && JSON.stringify(value).indexOf('.') > -1) {
    var array = JSON.stringify(value).split('.');
    var newArray = array[0] + '.' + array[1].substring(0, 2)
    return newArray
  } else if (typeof(value) == "string" && value.indexOf('.') > -1) {
    var array = value.split('.');
    var newArray = array[0] + '.' + array[1].substring(0, 2)
    return newArray
  } else {
    return parseInt(value)
  }
}
var styleBeforePrice = function(value) {
  // var value = parseFloat(value);
  if (typeof(value) == "number" && JSON.stringify(value).indexOf('.') > -1) {
    var array = JSON.stringify(value).split('.');
    var newArray = array[0]
    return newArray
  } else if (typeof(value) == "string" && value.indexOf('.') > -1) {
    var array = value.split('.');
    var newArray = array[0]
    return newArray
  } else {
    return parseInt(value)
  }
}
var styleAfterPrice = function(value) {
  if (typeof(value) == "number" && JSON.stringify(value).indexOf('.') > -1) {
    var array = JSON.stringify(value).split('.');
    var newArray = '.' + array[1]
    return newArray
  } else if (typeof(value) == "string" && value.indexOf('.') > -1) {
    var array = value.split('.');
    var newArray = '.' + array[1]
    if (newArray.length > 3) {
      return newArray.slice(0, 3);
    }
    return newArray;
  } else {
    return '.00'
  }
}
var setStorage = function(name, val) {
  window.localStorage.setItem(name, val)
}
var getStorage = function(name) {
  return window.localStorage.getItem(name);
}
var filterTime = function(value) {
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  return y + '.' + MM + '.' + d;
}
var filterWholeTime = function(value) {
  var value = parseInt(value * 1000);
  var date = new Date(value),
    Y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate(),
    H = date.getHours(),
    i = date.getMinutes(),
    s = date.getSeconds();
  if (m < 10) {
    m = '0' + m;
  }
  if (d < 10) {
    d = '0' + d;
  }
  if (H < 10) {
    H = '0' + H;
  }
  if (i < 10) {
    i = '0' + i;
  }
  if (s < 10) {
    s = '0' + s;
  }
  var t = Y + '/' + m + '/' + d + ' ' + H + ':' + i;
  return t
}
// 是否小于
var isLetterThan = function(a, b) {
  var a1 = parseFloat(a);
  var b1 = parseFloat(b);
  return a1 < b1;
}
var toPrice = function(value) {
  var price = value + '';
  if (price.indexOf('.') > -1) {
    var arr = price.split('.');
    return arr[0] + '.' + arr[1].substring(0, 2);
  } else {
    return price + '.' + '00';
  }
}
var getUrlCode = function() { // 截取url中的code方法
  var url = window.location.search
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
    var str = url.substr(1)
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
    }
  }
  // console.log(theRequest)
  return theRequest
  console.log(theRequest)
}
// 转换自提时间
/**
 * 时间戳转换为日期格式
 * @param {number} timestamp - 时间戳
 * @param {string} locale - 语言环境 ('zh'/'en')
 * @returns {string} 格式化后的日期字符串
 */
var formatPickDate = function(good, showTime = true) {
  if (!good) return ''

  const timestamp = good.pickup_time;
  const isMorePick = good.more_pickup_time_goods && good.more_pickup_time_goods.length > 1 ? true : false;
  const locale = window.localStorage.getItem('lang') || 'en';
  var date = new Date(timestamp * 1000);
  var month = (date.getMonth() + 1).toString();
  var day = date.getDate().toString();
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  console.log("d == " + hours + "cc = " + minutes)
  if (hours == 0 && minutes == 0) {
    showTime = false
  }
  // 获取星期
  const weekDayZh = ['日', '一', '二', '三', '四', '五', '六'];
  const weekDayEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const weekIndex = date.getDay();

  if (locale === 'zh') {
    if (showTime) {
      return isMorePick ? `最快${month}月${day}日 [週${weekDayZh[weekIndex]}] ${hours}:${minutes} 可自提` :
        `${month}月${day}日 [週${weekDayZh[weekIndex]}] ${hours}:${minutes} 可自提`;
    } else {
      return isMorePick ? `最快${month}月${day}日[週${weekDayZh[weekIndex]}]可自提` :
        `${month}月${day}日[週${weekDayZh[weekIndex]}]可自提`;
    }

  } else {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (showTime) {
      return isMorePick ?
        `Available as early as ${weekDayEn[weekIndex]}, ${monthNames[month-1]} ${day} ${hours}:${minutes}` :
        `Available on ${weekDayEn[weekIndex]}, ${monthNames[month-1]} ${day} ${hours}:${minutes}`;
    } else {
      return isMorePick ? `Available as early as ${weekDayEn[weekIndex]}, ${monthNames[month-1]} ${day}` :
        `Available on ${weekDayEn[weekIndex]}, ${monthNames[month-1]} ${day}`;
    }

  }
}
export {
  checkBroswer,
  showErrorToast,
  toFix,
  styleBeforePrice,
  styleAfterPrice,
  setStorage,
  getStorage,
  filterTime,
  isLetterThan,
  toPrice,
  filterWholeTime,
  getUrlCode,
  formatPickDate
}



// WEBPACK FOOTER //
// ./src/tools.js